import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Thanks from '../Tools/Thanks/Thanks'
import BookAnAppointment from '../Components/BookAnAppointment/BookAnAppointment'
import ThanksContact from '../Tools/ThanksContact/ThanksContact'
import PrivacyPolicy from '../Tools/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../Tools/TermsAndConditions/TermsAndConditions'
import HomePage from '../Components/HomePage/HomePage'
import AirDuct from '../Components/AirDuct/AirDuct'
import DryerVent from '../Components/DryerVent/DryerVent'
import Chimney from '../Components/Chimney/Chimney'
import Roofing from '../Components/Roofing/Roofing'
import HVAC from '../Components/HVAC/HVAC'
import ServicesAll from '../Components/ServicesAll/ServicesAll'
import ServicesPage from '../Components/ServicesPage/ServicesPage'
import HomePageCity from '../Components/HomePageCity/HomePageCity'
import SiteMap from '../Tools/SiteMap/SiteMap'
import NotFound from '../Tools/NotFound/NotFound'

export default function Main({ CitiePhone, CitiesData, navigateTo, locationsMain, WebSitePages }) {

    return (
        // <div>
        <Routes>
            <Route path="/" element={<HomePage locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* SEO landing pages (full nav + footer) — organic search lands here */}
            <Route path="/airduct/*" element={<AirDuct locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/dryer/*" element={<DryerVent locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/chimney/*" element={<Chimney locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/roofing/*" element={<Roofing locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/hvac/*" element={<HVAC locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* Ads landing pages (limited nav). Campaigns route to /local/{service}/* by ad type. */}
            <Route path="/local/airduct/*" element={<AirDuct locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/local/dryer/*" element={<DryerVent locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/local/chimney/*" element={<Chimney locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/local/roofing/*" element={<Roofing locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/local/hvac/*" element={<HVAC locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* Services index + per-service pages */}
            <Route path="/services" element={<ServicesAll CitiePhone={CitiePhone} />} />
            <Route path="/service/:service" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            <Route path="/service/:service/:city" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            {/* City pages */}
            <Route path="/city/:city" element={<HomePageCity CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            {/* Tools */}
            <Route path="/book/*" element={<BookAnAppointment CitiesData={CitiesData}  CitiePhone={CitiePhone} />} />
            <Route path="/thanks" element={<Thanks CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/thankscontact" element={<ThanksContact CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
             {/* Privacy Policy */}
             <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
            {/* SiteMap */}
            {["/sitemaps", "/sitemap", "/widgets"].map((path, index) =>
                <Route path={path} key={index} element={<SiteMap CitiePhone={CitiePhone} WebSitePages={WebSitePages} />} />
            )}
            <Route path="/sitemap/:id" element={<SiteMap CitiePhone={CitiePhone} WebSitePages={WebSitePages} />} />
            {/* 404 */}
            <Route path="*" element={<NotFound CitiePhone={CitiePhone} />} />
        </Routes>
        // </div>
    )
}
